import { testimonials } from "@/mocks/comics";

export default function TestimonialsSection() {
  return (
    <section id="reputation" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 text-accent-800 px-3 py-1 text-xs">
            <i className="ri-heart-2-fill"></i>用户口碑
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">追更用户都在说</h2>
          <p className="mt-3 text-sm text-foreground-600">来自 35 万+ 追更用户的真实评价，让追更更省心</p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {testimonials.map((t) => (
            <figure key={t.name} className="rounded-lg border border-background-200 bg-background-100 p-5 flex flex-col">
              <div className="flex gap-1 text-secondary-500">
                {[0, 1, 2, 3, 4].map((i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <blockquote className="mt-3 text-sm text-foreground-700 leading-relaxed flex-1">"{t.text}"</blockquote>
              <figcaption className="mt-4 flex items-center gap-3">
                <img src={t.avatar} alt={`${t.name}头像`} className="w-10 h-10 rounded-full object-cover" />
                <div>
                  <div className="text-sm font-medium text-foreground-950">{t.name}</div>
                  <div className="text-xs text-foreground-500">{t.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}